module.exports = __webpack_public_path__ + "static/img/10.81d33a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/10.png
// module id = Uejs
// module chunks = 0